import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { space } from 'styled-system';
import styled from '../../../styles/styled';
export const Switch = ({ label, onToggle, checked, disabled, size, monochrome, ...rest }) => {
    const handleToggle = useCallback(() => {
        if (disabled !== true) {
            onToggle(!checked);
        }
    }, [disabled, checked]);
    const handleKeyDown = useCallback((e) => {
        if (disabled !== true) {
            if (e.key === 'Tab') {
                return true;
            }
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleToggle();
            }
        }
        return false;
    }, []);
    return (_jsx(SwitchContainer, { role: "checkbox", "aria-label": label, "aria-checked": checked, checked: checked, onKeyDown: handleKeyDown, onClick: handleToggle, disabled: disabled, tabIndex: disabled ? -1 : 0, size: size, monochrome: monochrome, ...rest, children: _jsx(SwitchCircle, { checked: checked, disabled: disabled, monochrome: monochrome }) }));
};
Switch.defaultProps = {
    size: 'large',
};
const SwitchContainer = styled.div(({ checked, disabled, monochrome, theme, size }) => ({
    position: 'relative',
    display: 'inline-block',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transitionProperty: 'background-color, opacity',
    transitionDuration: '0.25s',
    transitionTimingFunction: 'ease',
    border: monochrome ? `1px solid ${theme.colors.phosphorGreen}` : undefined,
    backgroundColor: checked ? (monochrome ? theme.colors.phosphorGreen : theme.colors.azure) : (monochrome ? theme.colors.black : theme.colors.grey30),
    boxShadow: 'inset 0px 2px 2px rgba(44, 44, 44, 0.24), inset 0px 0px 2px rgba(0, 0, 0, 0.12)',
    opacity: disabled ? 0.3 : 1,
    '.js-focus-visible &:focus:not(.focus-visible)': {
        outline: 'none',
        boxShadow: 'inset 0px 2px 2px rgba(44, 44, 44, 0.24), inset 0px 0px 2px rgba(0, 0, 0, 0.12)',
    },
    height: '1.2em',
    width: '2em',
    borderRadius: '0.6em',
    fontSize: size === 'large' ? '20px' : '12px',
}), space);
const SwitchCircle = styled.div(({ checked, monochrome, theme }) => ({
    position: 'absolute',
    width: '1em',
    height: '1em',
    borderRadius: '50%',
    transition: 'right 0.25s ease',
    border: monochrome ? `1px solid ${theme.colors.phosphorGreen}` : undefined,
    backgroundColor: monochrome ? theme.colors.black : theme.colors.white,
    margin: '0.1em 0',
    right: checked ? '0.1em' : 'calc(100% - 1.1em)',
    boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.24)',
}));
//# sourceMappingURL=switch.js.map